import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventLodging(_event_id, _lodging) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // Ensure lodging is an array safely
                const lodging = Array.isArray(event.lodging) ? event.lodging.slice() : [];

                // 🟢 FIXED: Check permanent database IDs OR fallback to client-side temp_id tokens
                const idx = lodging.findIndex(m => {
                    if (!m || !_lodging) return false;

                    // Match Case A: Check primary server database keys
                    if (m.id != null && _lodging.id != null && String(m.id) === String(_lodging.id)) {
                        return true;
                    }

                    // Match Case B: Check client-side transient creation tokens
                    if (m.temp_id != null && _lodging.temp_id != null && String(m.temp_id) === String(_lodging.temp_id)) {
                        return true;
                    }

                    return false;
                });

                if (idx >= 0) {
                    // Update existing lodging; merge only defined fields to avoid overwriting with undefined
                    const base = lodging[idx];
                    const patch = _lodging;
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });
                    lodging[idx] = merged;
                } else {
                    // Add new lodging (Handles records incoming from peer socket updates natively)
                    lodging.push(_lodging);
                }

                // Write mutated collection array back to parent context object
                event.lodging = lodging;

                // Sanitize to avoid DataCloneError (functions, weird objects, etc.)
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Lodging with ID ${_lodging.id || 'TEMP'} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventLodging:", error);
            throw error;
        });
}

export function updateEventLodging(_event_id, _lodging) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure lodging is an array
                const lodging = Array.isArray(event.lodging) ? event.lodging.slice() : [];

                // prefer matching by id
                const idx = lodging.findIndex(m =>
                    m &&
                    _lodging &&
                    m.id != null &&
                    _lodging.id != null &&
                    String(m.id) === String(_lodging.id)
                );

                if (idx >= 0) {
                    const { merged, changed } = mergeChanged(lodging[idx], _lodging);
                    if (changed) lodging[idx] = merged;
                } else {
                    // add new lodging if not found
                    lodging.push(_lodging);
                }

                // write back
                event.lodging = lodging;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Lodging with ID ${_lodging.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventLodging:", error);
            throw error;
        });
}

export function deleteEventLodging(_event_id, _lodging_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite"); // Use 'readwrite' mode for updates
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const lodgingArray = Array.isArray(event.lodging) ? event.lodging : [];

                // Filter out the lodging with the specified ID
                const updatedLodging = lodgingArray.filter(lodging => {
                    if (!lodging) return false;
                    return String(lodging.id) !== String(_lodging_id);
                });

                // Update the event with the modified lodging array
                event.lodging = updatedLodging;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Lodging with ID ${_lodging_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventLodging:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}
